import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const fadeUp = () => {
	// Detect reduced motion preference
	const prefersReducedMotion = window.matchMedia(
		"(prefers-reduced-motion: reduce)"
	).matches;

	if (prefersReducedMotion) return;

	gsap.registerPlugin(ScrollTrigger);

	document.querySelectorAll(".fade-up").forEach((section) => {
		gsap.fromTo(
			section,
			{ opacity: 0, y: 50 }, // Initial state
			{
				opacity: 1,
				y: 0,
				duration: 0.8,
				ease: "power2.out", // Smooth fade-up
				scrollTrigger: {
					trigger: section,
					start: "top center+=100px", // Start animation when the top of the section is center of viewport with an offset of 100px
				},
			}
		);
	});
};

export default fadeUp;
